import { ItemsPerPage } from "components/Common/filters"
import Loader from "components/Common/loader"
import PaginationComponent from "components/Common/pagination"
import SidebarContext from "context/sidebar.context"
import React, { useContext, useEffect } from "react"
import { PiColumnsPlusLeft } from "react-icons/pi"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import defaultThumbnail from "../../assets/images/fileimage.png"
import {
  Card,
  CardBody,
  CardFooter,
  CardImg,
  CardText,
  CardTitle,
  Col,
  Row,
  Modal,
} from "reactstrap"
import {
  AllApplicationFetch,
  allApplications,
  RemoveRecommendationStd,
} from "redux/slice/applications/applicationSlice"
import { useState } from "react"
import { userData } from "redux/slice/user/userSlice"
import { SHUK_ROLE_VIWEWER } from "redux/enums"

function Recommendations() {
  const { userRole } = useSelector(userData) 
  const { applicationsData, loading, totalPages } = useSelector(allApplications)
  const {
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setActiveStates,
    setItemsPerPage,
  } = useContext(SidebarContext)
  const dispatch = useDispatch()
  const [deleteIdState, setDeleteIdState] = useState(null)
  const [deleteModalState, setDeleteModalState] = useState(false)
  const defaultImageUrl = defaultThumbnail

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  useEffect(() => {
    setActiveStates({
      main: "Recommendations",
      child: "",
    })
    let data = {
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      includeAll: true,
      isRecommended: true,
    }
    dispatch(AllApplicationFetch(data))
  }, [itemsPerPage, currentPage])

  const paginate = pageNumber => {
    console.log("paginate call with page number: ", pageNumber)
    setCurrentPage(pageNumber)
    let data = {
      pageNumber: pageNumber,
      includeAll: true,
      pageSize: itemsPerPage,
      isRecommended: true,
    }
    dispatch(AllApplicationFetch(data))
  }

  const handleItemsPerPage = perPage => {
    console.log("perPage", perPage)
    if (perPage !== itemsPerPage) {
      setCurrentPage(1)
    }
    setItemsPerPage(Number(perPage))
  }
  const getAge = item => {
    let today = new Date()
    let birthDate = new Date(item?.dateOfBirth)
    return today.getFullYear() - birthDate.getFullYear()
  }
  const combineName = item => {
    return item?.firstName + " " + item?.middleName + " " + item?.lastName
  }
  const isImage = url => {
    if (!url) return false
    return /\.(jpg|jpeg|png)$/i.test(url)
  }
  const openDeleteModal = id => {
    setDeleteIdState(id)
    setDeleteModalState(true)
  }
  const RemoveRecommendation = id => {
    dispatch(RemoveRecommendationStd({ studentId: id })).then(res => {
      if (res?.payload?.status === 200) {
        let data = {
          pageNumber: currentPage,
          pageSize: itemsPerPage,
          includeAll: true,
          isRecommended: true,
        }
        dispatch(AllApplicationFetch(data))
        setDeleteModalState(false)
      } 
    })
  }
  return (
    <div>
      <Row>
        <Col lg={12}>
          <Card className="app-table-card">
            <CardTitle className="fs-2 ms-3 dot-after">
              Scholarship Recommendations
            </CardTitle>
            <CardBody className="d-flex flex-wrap flex-column">
              <Row className="w-100">
                <div
                  className="float-end col-sm-12 col-md-12 d-flex justify-content-end flex-row align-items-center"
                  // style={{ width: "100%" }}
                >
                  <div>
                    <ItemsPerPage
                      value={itemsPerPage}
                      handleItemsPerPage={handleItemsPerPage}
                    />
                  </div>
                </div>
              </Row>
              <Row className="w-100">
                {loading ? (
                  <Row className="w-100">
                    <Col md={12} lg={12} sm={12} className="text-center">
                      <Loader />
                    </Col>
                  </Row>
                ) : (
                  applicationsData?.map((item, ind) => {
                    let _ans = item?.answers?.find(
                      e => e?.questionId == 3,
                    )?.answer
                    // let _cropedAns =
                    //   _ans?.length > 30 ? _ans?.slice(0, 30) + "..." : _ans

                    // let _address =
                    //   item?.homeAddress?.length > 30
                    //     ? item?.homeAddress?.slice(0, 30) + "..."
                    //     : item?.homeAddress

                    return (
                      <Col mg={6} lg={6} xl={3} className="mx-3 my-1" key={ind}>
                        <Card>
                          <CardImg
                            top
                            className="img-fluid"
                            src={
                              isImage(item?.passportImageUrl)
                                ? item?.passportImageUrl
                                : defaultImageUrl
                            }
                            style={{ height: "200px" }}
                            alt="Passport Size Picture"
                          />
                          <CardBody>
                            <div className="d-flex justify-content-between">
                              <CardTitle
                                style={{ width: "70%" }}
                                className="h3"
                              >
                                {combineName(item)}
                              </CardTitle>
                              <span>
                                Age:{" "}
                                <span
                                  style={{ fontSize: 12, fontWeight: "bold" }}
                                >
                                  {getAge(item)}{" "}
                                </span>
                              </span>
                            </div>
                            <div className="d-flex flex-column text-secondary-si">
                              <div className="d-flex align-items-center">
                                <span className="fw-medium">ID:&nbsp;</span>
                                <h5 className="mb-0 fs-6 fw-bold">
                                  {item?.applicationId}
                                </h5>
                              </div>
                              <div className="d-flex align-items-center hover-text">
                                <span className="fw-medium">Email:&nbsp;</span>
                                <h5 className="mb-0 fs-6 fw-bold text-truncate position-relative">
                                  {item?.email}
                                </h5>
                                <span
                                  className="tooltip-text"
                                  style={{ width: "auto", left: "0%" }}
                                >
                                  {item?.email}
                                </span>
                              </div>
                            </div>

                            <CardText>
                              {/* <p className="text-secondary fs-6">
                                Course of Study:{" "}
                                <span
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item?.programName}
                                </span>
                              </p> */}
                              <p className="d-flex align-items-center text-nowrap text-secondary fs-6">
                                Course of Study:&nbsp;
                                <span className="mb-0 fs-6 fw-bold text-truncate">
                                  {item?.programName}
                                </span>
                              </p>
                              <p className="d-flex align-items-center">
                                Address:&nbsp;
                                <span className="mb-0 fs-6 fw-bold text-truncate">
                                  {item?.homeAddress}
                                </span>
                              </p>
                              <p className="d-flex align-items-center text-nowrap">
                                Why ShukreIlahi:&nbsp;
                                <span className="mb-0 fs-6 fw-bold text-truncate">
                                  {_ans}
                                </span>
                              </p>
                              {/* <p>
                                Address:{" "}
                                <span
                                  className="text-truncate"
                                  style={{ fontSize: 12, fontWeight: "bold", maxWidth:"100%" }}
                                >
                                  {item?.homeAddress}
                                </span>
                              </p> */}
                              {/* <p>
                                Why ShukreIlahi:{" "}
                                <span
                                  style={{ fontSize: 12, fontWeight: "bold" }}
                                >
                                  {_ans}
                                </span>
                              </p> */}
                              <p>
                                Family Size:{" "}
                                <span
                                  style={{ fontSize: 12, fontWeight: "bold" }}
                                >
                                  {item?.totalHouseholdMembers}
                                </span>
                              </p>
                            </CardText>

                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                              <div>
                                <Link
                                  to={`/applications/${item?.id}?recommendation=true`}
                                  className=""
                                  onClick={() => {
                                    setActiveStates({
                                      main: "Application List",
                                      child: "",
                                    })
                                  }}
                                >
                                  <button className="switch-btn-sm-custom">
                                    View Application
                                  </button>
                                </Link>
                              </div>
                              {
                                !isViewer && (
                                  <div>
                                    <button
                                      className="switch-btn-sm-custom"
                                      onClick={() => openDeleteModal(item?.id)}
                                    >
                                      Remove Recommendation
                                    </button>
                                  </div>
                                )
                              }
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    )
                  })
                )}
              </Row>
            </CardBody>
            <CardFooter>
              <div className="d-flex justify-content-center justify-content-md-end justify-content-lg-end align-items-center flex-wrap">
                <div style={{ marginLeft: "4px" }}>
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    paginate={paginate}
                  />
                </div>
              </div>
            </CardFooter>
          </Card>
        </Col>
        <Modal isOpen={deleteModalState} centered>
          <Card className="bg-white">
            <CardBody className="mt-2">
              <h5 style={{ fontWeight: "normal" }}>
                Are you sure you want to remove this student's recommendation?
              </h5>
            </CardBody>
            <CardFooter>
              <div className="mt-4 float-end">
                <button
                  className="btn btn-danger me-2"
                  onClick={() => RemoveRecommendation(deleteIdState)}
                >
                  Yes
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => setDeleteModalState(false)}
                >
                  No
                </button>
              </div>
            </CardFooter>
          </Card>
        </Modal>
      </Row>
    </div>
  )
}

export default Recommendations
